import { render, staticRenderFns } from "./EnderecoEntrega.vue?vue&type=template&id=515a47aa&"
import script from "./EnderecoEntrega.vue?vue&type=script&lang=js&"
export * from "./EnderecoEntrega.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoEntrega.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EnderecoEntrega.vue"
export default component.exports